export const state = {
  isConnected: false,
  event: ""
};
